import React from 'react';

function Mitos() {
    return (
        <div className="row">
                    <div className="col-12">
                        <div className=" text-center mb-5 bg-white p-md-5 pb-2 p-2" style={{borderRadius:"20px"}}>
                            <h2>Mitos & Fakta</h2>
                            <hr/>
                            <div className="row ">
                                <div className="col-md-6 col-12 p-md-5 pb-2 ">
                                    <img className="w-100 rounded-lg" src={require('../../assets/img/post/post-01.png')} alt="post1"/>
                                </div>
                                <div className="col-md-6 col-12 p-md-5 pb-2 ">
                                    <img className="w-100 rounded-lg" src={require('../../assets/img/post/post-02.png')} alt="post1"/>
                                </div>
                                <div className="col-md-6 col-12 p-md-5 pb-2 ">
                                    <img className="w-100 rounded-lg" src={require('../../assets/img/post/post-03.png')} alt="post1"/>
                                </div>  
                                <div className="col-md-6 col-12 p-md-5 pb-2 ">
                                    <img className="w-100 rounded-lg" src={require('../../assets/img/post/post-04.png')} alt="post1"/>
                                </div>  
                                <div className="col-md-6 col-12 p-md-5 pb-2 ">
                                    <img className="w-100 rounded-lg" src={require('../../assets/img/post/post-05.png')} alt="post1"/>
                                </div>  
                                <div className="col-md-6 col-12 p-md-5 pb-2 ">
                                    <img className="w-100 rounded-lg" src={require('../../assets/img/post/post-06.png')} alt="post1"/>
                                </div>  
                                <div className="col-md-6 col-12 p-md-5 pb-2 ">
                                    <img className="w-100 rounded-lg" src={require('../../assets/img/post/post-07.png')} alt="post1"/>
                                </div>  
                                <div className="col-md-6 col-12 p-md-5 pb-2 ">
                                    <img className="w-100" src={require('../../assets/img/post/post-08.png')} alt="post1"/>
                                </div>  
                            </div>
                            
                        </div>
                    </div>
                </div>
    )
}

export default Mitos;
